import React from 'react';
import { LayoutItemProps } from '../../components/LayoutItem';

export const LayoutItemRaw = (props: LayoutItemProps) => <div key={props.key}>{props.children}</div>;
